export default __webpack_public_path__ + "static/WorkSans-Regular-a11c276b0704ee65768387fa43b1c00c.woff2";